import { z } from 'zod';
import {
    HoldingCreateForm,
    HoldingCreateFormErrors,
    HoldingCreateFormErrorsSchema,
} from '@/types/holding/holding-create-form.type.ts';
import { HoldingStatus } from '@/types/holding/holding-status.type.ts';

export type HoldingUpdateForm = HoldingCreateForm & {
    status: HoldingStatus,
};

export type HoldingUpdateFormErrors = HoldingCreateFormErrors & {
    status?: string[],
};

export const HoldingUpdateFormErrorsSchema = HoldingCreateFormErrorsSchema.extend({
    status: z.array(z.string()).optional(),
});
